import React from 'react';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const CopyNominal = (props) => {
    return (
        <div className='popup-box'>
            <h4 className="title">{props.t('information')}</h4>
            <div className="popup-error-msg">
                {props.copyNominalText}
            </div>
        </div>
    )
}

CopyNominal.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(CopyNominal);